import React from 'react';
import { Text, Pressable, View } from 'react-native';
import PropTypes from 'prop-types';
import Icon from 'LocalGluons/components/Icon';
import LineIndicator from '../LineIndicator';

import defaultStyles from './ProgramItem.jss';
import { CachedImage } from '../CachedImage';

const ProgramItem = ({
    iconUrl,
    onIconPress,
    onDescriptionPress,
    title,
    subTitle,
    progress,
    iconName,
    testID,
    isContentLocked,
    isContentHidden
}) => (
    <View testID={testID} style={defaultStyles.container}>
        <Pressable style={defaultStyles.iconContainer} onPress={onIconPress}>
            <CachedImage
                source={{ uri: iconUrl }}
                style={defaultStyles.icon}
                resizeMode="contain"
            />
        </Pressable>
        <Pressable style={[defaultStyles.contentWrapper]} onPress={onDescriptionPress}>
            <View style={defaultStyles.content}>
                <Text
                    numberOfLines={1}
                    style={[
                        defaultStyles.programTitle,
                        isContentHidden && defaultStyles.programTitleHidden
                    ]}
                >
                    {isContentHidden ? 'Locked content' : title}
                </Text>
                {isContentLocked && (
                    <View style={defaultStyles.iconWrapper}>
                        <Icon style={defaultStyles.lockIcon} name={iconName} />
                    </View>
                )}
            </View>
            <Text numberOfLines={1} style={defaultStyles.programSubtitle}>
                {subTitle}
            </Text>
            {progress > 0 ? <LineIndicator progress={progress} /> : null}
        </Pressable>
    </View>
);

ProgramItem.defaultProps = {
    iconUrl: '',
    iconName: '',
    title: '',
    subTitle: '',
    progress: 0,
    onIconPress: () => {},
    onDescriptionPress: () => {},
    testID: undefined
};

ProgramItem.propTypes = {
    iconUrl: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    progress: PropTypes.number,
    onIconPress: PropTypes.func,
    onDescriptionPress: PropTypes.func,
    iconName: PropTypes.string,
    testID: PropTypes.string
};

export default ProgramItem;
